<template>
	<div class="holder" :class="{ closed, border }">
		<div
			class="header box-border"
			:class="{ title }"
			:style="{
				'max-width': headerWidth ? `${headerWidth}px` : 'unset'
			}"
			@click="toggle"
		>
			<h3 v-if="title" :class="{ small }">
				{{ currentTitle }}
			</h3>
			<i class="lni lni-chevron-down" v-if="closed" />
			<i class="lni lni-chevron-up" v-else />
		</div>
		<slot />
	</div>
</template>

<script>
export default {
	name: 'uiFold',
	props: {
		title: String,
		small: Boolean,
		border: Boolean,
		openedTitle: String,
		openedAtMount: Boolean,
		headerWidth: String
	},
	data() {
		return {
			closed: true,
		}
	},
	computed: {
		currentTitle() {
			if (this.openedTitle && !this.closed) return this.openedTitle
			return this.title
		},
	},
	mounted() {
		if (this.openedAtMount) this.closed = false
	},
	methods: {
		toggle(e) {
			this.closed = !this.closed
			this.$emit('click', e)
		},
		close() {
			this.closed = true
		},
		open() {
			this.closed = false
		},
	},
}
</script>

<style lang="less" scoped>
@import '../../assets/app.less';

.holder {
	width: 100%;
	height: fit-content;
	box-sizing: border-box;
	margin: 5px 0;

	&.border {
		border-bottom: 2px solid @grey;
	}

	&.closed {
		height: 50px;
		overflow: hidden;
	}
}

.header {
	height: 50px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	cursor: pointer;
	background: @grey;
	border-radius: 16px;
	padding: 0 16px;
	margin-bottom: 10px;

	h3 {
		font-size: 14px;
	}

	&.title {
		justify-content: space-between;
	}

	i {
		margin-right: 10px;
		opacity: 0.3;
	}
}
</style>
